import { store } from 'redux/store';

import { getSharesByHoldingClassOrPartner } from 'modules/partners/api/getSharesByHoldingClassOrPartner';

import { CustomRange } from '../types/CustomRange';

type GetNewRangeProps = {
  holdingClassId: string | undefined;
  sharesCount: number;
  classEditedRanges: CustomRange[];
};

const getDefaultRange = (sharesCount: number) => ({ from: 1, to: sharesCount });

const getEditedRange = (
  classEditedRanges: CustomRange[],
  sharesCount: number
) => {
  const sortedRanges = classEditedRanges.sort(
    (a, b) => (a.newFrom || 0) - (b.newFrom || 0)
  );
  const lastEditedRange = sortedRanges[sortedRanges.length - 1];
  return {
    from: (lastEditedRange.newTo || 0) + 1,
    to: (lastEditedRange.newTo || 0) + sharesCount,
  };
};

const getLastRangeFromShares = async (
  holdingClassId: string,
  sharesCount: number
) => {
  const sharesData = await store.dispatch(
    getSharesByHoldingClassOrPartner({
      holdingClassId,
      params: {
        page: 1,
        items: 1,
        sortBy: 'from',
        sortOrder: 'desc',
        fieldsToPopulate: ['shareClass'],
      },
    })
  );

  const ranges = sharesData?.shares || [];
  if (ranges.length === 0) {
    return { from: 1, to: sharesCount };
  }
  const lastRange = ranges[0];
  return { from: lastRange.to + 1, to: lastRange.to + sharesCount };
};

export const getNewRange = async ({
  holdingClassId,
  sharesCount,
  classEditedRanges,
}: GetNewRangeProps) => {
  if (!holdingClassId) return getDefaultRange(sharesCount);

  if (classEditedRanges.length > 0) {
    return getEditedRange(classEditedRanges, sharesCount);
  }

  return getLastRangeFromShares(holdingClassId, sharesCount);
};
